import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "orderByGf",
})
export class OrderByGfPipe implements PipeTransform {
    transform(value: any[], ...args: any[]): any[] {
        if (!value || value.length === 0) {
            return [];
        }
        return value.sort((a, b) => a.value.gf - b.value.gf);
    }
}
